module.exports = __webpack_public_path__ + "media/images/redesign-images/icons/icon-entry-level-0fd90bc8768441b4c03f8823d1d0b8ec.svg";